import {CSSResult, html, LitElement, nothing, unsafeCSS} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {consume} from '@lit/context';
import {sharedCss} from '../../../scripts/style-bundle/shared.js';
import baseLayerStyles from '../base-layer/base-layer.scss';
import styles from './curator-layer.scss';
import {Messages} from '../../../@types/wishlist.js';
import {i18nContext} from '../../../scripts/context/i18nContext.js';
import {curatorLayerContext, CuratorLayerState} from '../../../scripts/context/curatorLayerContext.js';
import {hideIconFromAssistiveTechnology} from '../icon/icon-accessibility.js';
import phoneIcon from '@breuni-ui/bdk/design-tokens/images/icons/o-ic-24_phone-old.svg';
import mailIcon from '@breuni-ui/bdk/design-tokens/images/icons/o-ic-24_mail.svg';
import whatsappIcon from '@breuni-ui/bdk/design-tokens/images/icons/o-ic-24_whatsapp.svg';
import chevronRightIcon from '@breuni-ui/bdk/design-tokens/images/icons/o-ic-24_chevron-right.svg';

@customElement('ents-curator-layer')
export class CuratorLayer extends LitElement {

  @consume({context: curatorLayerContext, subscribe: true})
  @property({attribute: false})
  private state!: CuratorLayerState;

  @consume({context: i18nContext})
  private messages!: Messages;

  static get styles(): CSSResult[] {
    return [sharedCss, unsafeCSS(styles), unsafeCSS(baseLayerStyles)];
  }

  private closeLayer() {
    if (this.state.open) {
      this.state.update({open: false});
    }
  }

  protected render() {
    const curator = this.state.curator;

    if (!curator) {
      return nothing;
    }

    const roleSubtitle = this.messages['ents_wishlist_curator_details_subtitle'] ?? '';
    const waNumber = curator?.phone.replace(/\D/g, '') ?? '';

    return html`
      <ents-base-layer
        drawer-test-id="ents-curator-layer"
        ?showLayer="${this.state.open}"
        @ents-layer-closed="${this.closeLayer}"
      >
        <div class="ents-curator-layer-content">
          <div class="ents-curator-layer-profile">
            <img src="${curator.image}" alt="${curator.name}" class="ents-curator-layer-profile__image"/>
            <h2 class="ents-heading-medium ents-curator-layer-profile__name">${curator.name}</h2>
            <p class="ents-copy ents-curator-layer-profile__role">${roleSubtitle}</p>
          </div>

          <div class="ents-curator-layer-actions">

            <a @click="${this.closeLayer}" href="tel:${curator.phone}" class="ents-curator-layer-action"
               data-test-ents-curator-phone>
              <div class="ents-curator-layer-action__content">
                ${hideIconFromAssistiveTechnology(phoneIcon())}
                <div class="ents-curator-layer-action__text">
                  <span class="ents-copy-bold">${this.messages['ents_wishlist_curator_details_phone']}</span>
                  <span class="ents-copy">${curator.phone}</span>
                </div>
              </div>
              <div class="ents-curator-layer-action__chevron">
                ${hideIconFromAssistiveTechnology(chevronRightIcon())}
              </div>
            </a>

            <a @click="${this.closeLayer}" href="https://wa.me/${waNumber}" target="_blank" rel="noopener noreferrer"
               class="ents-curator-layer-action" data-test-ents-curator-whatsapp>
              <div class="ents-curator-layer-action__content">
                ${hideIconFromAssistiveTechnology(whatsappIcon())}
                <div class="ents-curator-layer-action__text">
                  <span class="ents-copy-bold">${this.messages['ents_wishlist_curator_details_whatsapp']}</span>
                  <span class="ents-copy">${curator.phone}</span>
                </div>
              </div>
              <div class="ents-curator-layer-action__chevron">
                ${hideIconFromAssistiveTechnology(chevronRightIcon())}
              </div>
            </a>

            <a @click="${this.closeLayer}" href="mailto:${curator.eMail}" class="ents-curator-layer-action"
               data-test-ents-curator-mail>
              <div class="ents-curator-layer-action__content">
                ${hideIconFromAssistiveTechnology(mailIcon())}
                <div class="ents-curator-layer-action__text">
                  <span class="ents-copy-bold">${this.messages['ents_wishlist_curator_details_email']}</span>
                  <span class="ents-copy">${curator.eMail}</span>
                </div>
              </div>
              <div class="ents-curator-layer-action__chevron">
                ${hideIconFromAssistiveTechnology(chevronRightIcon())}
              </div>
            </a>

          </div>
        </div>
      </ents-base-layer>
    `;
  }
}
